import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit", "input"];
  connect() {
    this.toggleSaveButton();
  }

  attachFile() {
    const fileInput = this.element.querySelector('input[type="file"]');
    this.submitTarget.disabled = !(fileInput && fileInput.files.length > 0);
  }
  
  toggleSaveButton() {
    const fileInput = document.getElementById("file-upload");
    const saveButton = document.getElementById("save-button");
    const radioButtons = document.querySelectorAll("input[name='list_type']");
    const downloadBtn = document.querySelector("#download-template-btn");
    
    if (!fileInput || !saveButton) return;
    
    const isFileSelected = fileInput.files.length > 0;
    const isRadioSelected = Array.from(radioButtons).some(radio => radio.checked);
    const selectedRadio = Array.from(radioButtons).find(radio => radio.checked);

    saveButton.disabled = !(isFileSelected && isRadioSelected);

    if (downloadBtn) {
      if (selectedRadio) {
        downloadBtn.classList.remove("disabled");
        downloadBtn.removeAttribute("disabled");

        if (selectedRadio.value === "standard") {
          downloadBtn.href = downloadBtn.getAttribute("data-standard-template");
          downloadBtn.setAttribute("download", "exhibitors-template-standard.xlsx");
        } else if (selectedRadio.value === "hpma") {
          downloadBtn.href = downloadBtn.getAttribute("data-hpma-template");
          downloadBtn.setAttribute("download", "exhibitors-template-hpma.xlsx");
        }
      } else {
        downloadBtn.classList.add("disabled");
        downloadBtn.setAttribute("disabled", true);
        downloadBtn.removeAttribute("href");
        downloadBtn.removeAttribute("download");
      }
    }
  }

  // Phase 2 (Task 10): used by the Event Comparison event selector to
  // trigger a GET form submit whenever a checkbox changes. Prefers
  // requestSubmit so Turbo's data-turbo-frame attribute is honored;
  // falls back to .submit() in older browsers that lack the API.
  submit() {
    const form = this.element.closest('form') || this.element.querySelector('form')
    if (!form) return
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
